<template>
  <el-dialog
    title="选择商品"
    width="800px"
    :visible.sync="visible"
    :before-close="handleClose"
  >
    <customize-table
      :formConfig="getFormConfig()"
      :filterObj="filterObj"
      :columns="columns"
      :data="dataList"
      :loading="loading"
      :pagination="pagination"
      @on-selection-change="onSelectionChange"
    >
      <div slot="footer">
        <el-button style="margin-right: 10px" type="primary" @click="search">
          搜索
        </el-button>
        <el-button style="margin-right: 10px" @click="reset">重置</el-button>
      </div>
    </customize-table>

    <el-button style="margin-top: 20px" type="primary" @click="save">
      保存
    </el-button>
  </el-dialog>
</template>

<script>
import CustomizeTable from "@/components/customize-table";
import { mapActions, mapGetters } from "vuex";
import Page from "@/mixin/Page";
import { pickBy, isEmpty, isNumber } from "lodash";
export default {
  components: {
    CustomizeTable,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [Page],
  created() {
    this.fetch();
  },
  data() {
    return {
      loading: false,
      dataList: [],
      selectedRows: [],
      columns: [
        {
          type: "selection",
          width: 50,
          align: "center",
          fixed: "left",
        },
        {
          title: "货主id",
          key: "customerId",
          align: "center",
        },
        {
          title: "商品条码",
          key: "barcodes",
          align: "center",
        },
        {
          title: "商品名称",
          key: "declareName",
          align: "center",
        },
        {
          title: "海关数量",
          key: "stockCustomsNum",
          align: "center",
        },
        {
          title: "库存数量",
          key: "wmsNum",
          align: "center",
        },
      ],
      filterObj: {
        customerId: "",
        itemNo: "",
      },
    };
  },
  methods: {
    ...mapActions("record", ["queryList"]),
    handleClose() {
      this.$emit("close");
    },
    save() {
      this.$emit("on-select", this.selectedRows);
    },
    onSelectionChange(rows) {
      this.selectedRows = rows;
    },
    getFilterParams() {
      const data = pickBy(
        this.filterObj,
        (v) => !isEmpty(v) || (isNumber(v) && parseInt(v))
      );
      return data;
    },
    fetch() {
      this.loading = true;
      const filterParams = Object.assign({}, this.getFilterParams());
      let searchCondition = {
        request: {
          queryInfo: { ...filterParams },
          pageInfo: {
            currentPage: this.pagination.currentPage,
            pageSize: this.pagination.pageSize,
          },
        },
      };
      this.queryList(searchCondition)
        .then((res) => {
          this.loading = false;
          this.dataList = res.items || [];
          const pageInfo = res.pageInfo || { totalCount: 0 };
          this.pagination.totalCount = pageInfo.totalCount;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    getFormConfig() {
      return [
        {
          data: [
            {
              label: "货主id",
              model: "customerId",
              type: "SELECT",
              props: {
                data: this.getCustomerList,
              },
            },
            {
              label: "料号",
              model: "itemNo",
              type: "INPUT",
            },
          ],
        },
      ];
    },
  },
  computed: {
    ...mapGetters({
      getCustomerList: "getCustomerList",
    }),
  },
};
</script>
